import Vue from "vue";
import initService from "@/common/api-services/init-service";
import sessionIdDirective from "@/common/directive/sessionId-directive";

let baseurl = `${process.env.VUE_APP_CONFIG_BASEURL}`;
let apikey = `${process.env.VUE_APP_CONFIG_APIKEY}`;
let userName = initService.getUserNameInfo();
let customer = initService.getCustomerInfo();
let group = initService.getGroupInfo();
let pId = sessionIdDirective.getJSessionId();
let headers = {
	headers: {
		"Content-Type": "application/json",
		"x-api-key": apikey,
	},
};

const productManagementService = {

	getNsim() {
		let url = `${baseurl}?method=IOT_GetNSIMGTList&customer=${customer}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});

	},

	getNsimLocations() {
		let url = `${baseurl}?method=IOT_GetNSIMGTLocations&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	addNsim(params) {
		const queryParams = new URLSearchParams(params).toString();

		let url = `${baseurl}?method=IOT_AddNSIMGT&${queryParams}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	updateNsim(params) {
		const queryParams = new URLSearchParams(params).toString();

		let url = `${baseurl}?method=IOT_EditNSIMGT&${queryParams}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	deleteNsim(id) {
		let url = `${baseurl}?method=IOT_DeleteNSIMGT&gt=${id}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	getSubscriberProducts() {
		let url = `${baseurl}?method=IOT_GetProductsList&customer=${customer}&mcc=316&limit=50`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	addSubscriberProducts(params) {
		const queryParams = new URLSearchParams(params).toString();

		let url = `${baseurl}?method=IOT_AddProduct&customer=${customer}&${queryParams}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	updateSubscriberProducts(params) {
		const queryParams = new URLSearchParams(params).toString();

		let url = `${baseurl}?method=IOT_UpdateProduct&customer=${customer}&${queryParams}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	deleteSubscriberProducts(id) {
		let url = `${baseurl}?method=IOT_DeleteProduct&id=${id}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	getNsimRules() {
		let url = `${baseurl}?method=IOT_GetNSIMRulesList&customer=${customer}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	addNsimRules(params) {
		const queryParams = new URLSearchParams(params).toString();

		let url = `${baseurl}?method=IOT_AddNSIMRules&${queryParams}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	updateNsimRules(params) {
		const queryParams = new URLSearchParams(params).toString();

		let url = `${baseurl}?method=IOT_EditNSIMRules&${queryParams}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	deleteNsimRules(id) {
		let url = `${baseurl}?method=IOT_DeleteNSIMRules&id=${id}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	getShortCodes() {
		let url = `${baseurl}?method=IOT_GetShortcodeList&customer=${customer}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	addShortCodes(params) {
		const queryParams = new URLSearchParams(params).toString();
		let url = `${baseurl}?method=IOT_AddShortcode&${queryParams}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	updateShortCodes(params) {
		const queryParams = new URLSearchParams(params).toString();
		let url = `${baseurl}?method=IOT_UpdateShortcode&${queryParams}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	deleteShortCodes(dialed) {
		let url = `${baseurl}?method=IOT_DeleteShortcode&dialed=${dialed}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	getProductList() {
		let url = `${baseurl}?method=IOT_GetProductsList&customer=${customer}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	getNsimGTList() {
		let url = `${baseurl}?method=IOT_GetNSIMGTList&customer=${customer}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	getShortcodeCarrierList() {
		let url = `${baseurl}?method=IOT_GetShortcodeCarrierList&customer=${group}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	downloadNsimGT() {
		let url = `${baseurl}?method=IOT_GetNSIMGTList&download_csv&customer=${customer}`;
		return Vue.axios.get(url, {
			responseType: "blob",
		});
	},

	TestNSIMGT(params) {
		const queryParams = new URLSearchParams(params).toString();
		let url = `${baseurl}?method=IOT_TestNSIMGT&${queryParams}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	TestActionsNSIMGT(params) {
		const queryParams = new URLSearchParams(params).toString();
		let url = `${baseurl}?method=IOT_TestActionsNSIMGT&${queryParams}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	ClearNSIMGT() {
		let url = `${baseurl}?method=IOT_ClearNSIMGT`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	InsertNSIMGTData(params) {
		const queryParams = new URLSearchParams(params).toString();
		let url = `${baseurl}?method=IOT_InsertNSIMGTData&${queryParams}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},

	InsertShortcodeData(params) {
		const queryParams = new URLSearchParams(params).toString();
		let url = `${baseurl}?method=IOT_InsertShortcodeData&${queryParams}`;
		return Vue.axios.get(url, headers)
			.then((res) => {
				return res.data.message;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default productManagementService;
